/**
 * **Tabs von Projekten, die es nicht mehr gibt** (gemeldet 27.09.2026).
 *
 * Tabs liegen in localStorage, Projekte in der Datenbank. Löscht man ein
 * Projekt in diesem Fenster, schließt die Sidebar seinen Tab selbst. Fehlt es
 * aus anderem Grund — auf einem anderen Gerät gelöscht und per Sync entfernt,
 * Datenbank geleert —, blieb der Tab mit altem Namen stehen und zeigte ins Leere.
 *
 * Geprüft wird nur gegen eine Abfrage, die **genau diese Projekt-IDs** gestellt
 * hat: Solange die Abfrage zu alten IDs gehört (ein Tab kam gerade dazu), ist
 * nichts „fehlend“ — sonst ginge ein frisch geöffneter Tab sofort wieder zu.
 */
export interface ProjectLookup {
  /** Die IDs, nach denen gefragt wurde. */
  ids: readonly string[]
  /** Was die Datenbank dazu fand. */
  rows: ReadonlyArray<{ id: string; deletedAt?: Date | null }>
}

const PROJECT_PATH = /\/project\/([^/]+)/

export function staleProjectTabs<T extends { path: string }>(tabs: readonly T[], lookup: ProjectLookup | undefined): T[] {
  if (!lookup) return []
  const asked = new Set(lookup.ids)
  const alive = new Set(lookup.rows.filter(row => !row.deletedAt).map(row => row.id))
  return tabs.filter(tab => {
    const id = PROJECT_PATH.exec(tab.path)?.[1]
    return id !== undefined && asked.has(id) && !alive.has(id)
  })
}
